import React, { useEffect } from 'react';
import OrderListByProductsTable from '../../../../components/Widgets/Tables/OrderListByProductsTable';
import '../../StoreDashboard/style.css'

const OrderDetailsPage = ({ setActivePath }) => {
      
  useEffect(() => {
        setActivePath("Manage Orders");
    }, [setActivePath]);


    return (
        <div className="outlet-container">
            <div className="background-white">
                
            </div>
        </div>
    );
};

export default OrderDetailsPage;
